import { AppIdentifier } from "../../types";
import { appIdentifierToActionPrefixMap } from "../../types";
import {
  ACTION_SET_JWT,
  ACTION_SET_MODAL_STATE,
  ACTION_APP_LOADED,
  ACTION_SET_DEPOSIT_ID,
  ACTION_SET_WALLET_ADDRESS
} from "./constants";

export interface ITravelRuleState {
  jwt: string;
  isAppLoaded: boolean;
  isAppActive: boolean;
  depositId?: string;
  walletAddress?: string;
}

export interface ITravelRuleAction {
  type: string;
  jwt?: string;
  isAppActive?: boolean;
  isAppLoaded?: boolean;
  depositId?: string;
  walletAddress?: string;
}

const INITIAL_STATE: ITravelRuleState = {
  jwt: "",
  isAppActive: false,
  isAppLoaded: false
}

const applySetIsAppActive = (state: ITravelRuleState, action: ITravelRuleAction) : ITravelRuleState => {
  return {
      ...state,
      isAppActive: !!action.isAppActive,
  }
}

const applySetSendJWTToApp = (state: ITravelRuleState, action: ITravelRuleAction) : ITravelRuleState => {
  return {
      ...state,
      isAppLoaded: !!action.isAppLoaded,
  }
}

const applySetJWT = (state: ITravelRuleState, action: ITravelRuleAction) : ITravelRuleState => {
  return {
      ...state,
      jwt: action.jwt as string,
  }
}

const applySetDepositId = (state: ITravelRuleState, action: ITravelRuleAction) : ITravelRuleState => {
  return {
      ...state,
      depositId: action.depositId,
  }
}

const applySetWalletAddress = (state: ITravelRuleState, action: ITravelRuleAction) : ITravelRuleState => {
  return {
      ...state,
      walletAddress: action.walletAddress,
  }
}

const reducerMap: { [actionType: string]: (state: ITravelRuleState, action: ITravelRuleAction) => ITravelRuleState } = {
  // Travel rule reducer
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.TRAVEL_RULE)}${ACTION_SET_JWT}`]: applySetJWT,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.TRAVEL_RULE)}${ACTION_SET_MODAL_STATE}`]: applySetIsAppActive,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.TRAVEL_RULE)}${ACTION_APP_LOADED}`]: applySetSendJWTToApp,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.TRAVEL_RULE)}${ACTION_SET_DEPOSIT_ID}`]: applySetDepositId,
  [`${appIdentifierToActionPrefixMap.get(AppIdentifier.TRAVEL_RULE)}${ACTION_SET_WALLET_ADDRESS}`]: applySetWalletAddress,
};

const travelRuleReducer = (state = INITIAL_STATE, action: ITravelRuleAction) => {
  if (!!action.type && !!reducerMap[action.type]) {
      return reducerMap[action.type](state, action);
  } else {
      return state;
  }
}

export default travelRuleReducer;
